import React from "react";

import SearchIcon from "@material-ui/icons/Search";

import "./SearchBar.scss";

const SearchBar = ({
  value,
  onSearch,
  placeholder,
  icon = <SearchIcon style={{ color: "#e94686" }} />,
  style = {},
}) => {
  return (
    <div className="search-bar-container" style={style}>
      {icon && icon}
      <input
        type="text"
        placeholder={placeholder ?? "Search"}
        value={value}
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
